import {getMethod} from '~/api'

async function get(request, cancelToken) {
    return await getMethod('/proxy/searchInsurance', request, cancelToken)
}

export {get}
